import React, { PropTypes } from 'react';
import { Form } from 'semantic-ui-react';
import { Link } from 'react-router';
import { compose, withState, withHandlers } from 'recompose';

import ValidateLogin from '../../../enhancers/ValidateLogin';


const { Input, Button } = Form;

const propTypes = {
  passwordLabel: PropTypes.string.isRequired,
  confirmPasswordLabel: PropTypes.string.isRequired,
  buttonLabel: PropTypes.string.isRequired,
  loading: PropTypes.bool,
  backLink: PropTypes.string,
  backLabel: PropTypes.string,
  isPasswordValid: PropTypes.bool.isRequired,
  arePasswordsEqual: PropTypes.bool.isRequired,
  nameLabel: PropTypes.string.isRequired,
  emailLabel: PropTypes.string.isRequired,
  isNameValid: PropTypes.bool,
  isEmailValid: PropTypes.bool,
  updateEmail: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  updateName: PropTypes.func.isRequired,
  updatePassword: PropTypes.func.isRequired,
  password: PropTypes.string.isRequired,
  updateConfirmation: PropTypes.func.isRequired,
  confirmation: PropTypes.string.isRequired,
  submitNewAccount: PropTypes.func.isRequired,
};

const CreateAccountForm = (props) => {
  const {
    passwordLabel,
    confirmPasswordLabel,
    buttonLabel,
    loading,
    backLink,
    backLabel,
    isPasswordValid,
    arePasswordsEqual,
    nameLabel,
    emailLabel,
    isNameValid,
    isEmailValid,
    updateEmail,
    name,
    email,
    updateName,
    updatePassword,
    password,
    updateConfirmation,
    confirmation,
    submitNewAccount,
  } = props;

  return (
    <Form onSubmit={submitNewAccount}>
      <Input
        onChange={updateName}
        name="name"
        label={nameLabel}
        value={name}
        type="text"
        error={!isNameValid}
      />
      <Input
        onChange={updateEmail}
        name="email"
        label={emailLabel}
        type="email"
        value={email}
        error={!isEmailValid}
      />
      <Input
        onChange={updatePassword}
        name="password"
        label={passwordLabel}
        type="password"
        value={password}
        error={!isPasswordValid}
      />
      <Input
        onChange={updateConfirmation}
        name="confirmPassword"
        label={confirmPasswordLabel}
        type="password"
        value={confirmation}
        error={!arePasswordsEqual}
      />
      <Button color="red" loading={loading} floated="right">{buttonLabel}</Button>
      {
        backLabel && backLink
        && <Link to={backLink}>{backLabel}</Link>
      }
    </Form>
  );
};

CreateAccountForm.propTypes = propTypes;

const enhance = compose(
  withState('isNameValid', 'nameValidation', true),
  withState('isEmailValid', 'emailValidation', true),
  withState('isPasswordValid', 'passwordValidation', true),
  withState('arePasswordsEqual', 'confirmPassword', true),
  withState('name', 'updateName', ''),
  withState('email', 'updateEmail', ''),
  withState('password', 'updatePassword', ''),
  withState('confirmation', 'updateConfirmation', ''),
  withHandlers(ValidateLogin),
);

export default enhance(CreateAccountForm);



/** WEBPACK FOOTER **
 ** ./src/app/modules/login/components/createAccountCard/createAccountForm/CreateAccountForm.js
 **/